

const UPDATE_OPEN = 'UPDATE_OPEN';
const UPDATE_TYPE_ID = 'UPDATE_TYPE_ID';
const OPEN_EDIT_ITEM = 'OPEN_EDIT_ITEM';
const CLOSE_DIALOG = 'CLOSE_DIALOG';

const TYPE_PROPERTIES_LOADED = 'TYPE_PROPERTIES_LOADED';

const itemDialog = {
    open: false,
    typeId: 0,
    itemId: 0
};


export default function itemDialogReducer(state = itemDialog, { type, payload }) {

    switch (type) {

        case UPDATE_OPEN:
        case UPDATE_TYPE_ID:
        case OPEN_EDIT_ITEM:
        case CLOSE_DIALOG:
            let newState = { ...state, ...payload }
            return newState;

        default:
            return state;
    }
}


export const openItemDialog = open => ({
    type: UPDATE_OPEN,
    payload: { open: open }
});

export const setItemTypeId = typeId => ({
    type: UPDATE_TYPE_ID,
    payload: { typeId: typeId }
});

export const openEditItem = itemId => ({
    type: OPEN_EDIT_ITEM,
    payload: { itemId: itemId, open: true }
});

export const closeDialog = () => ({
    type: CLOSE_DIALOG,
    payload: { open:false,typeId:0, itemId: 0 }
});